import React from 'react';
import { formatNarrowWeekday } from '@/utils/date';
import { tv } from '@/utils/tv';

const item = tv({
  base: 'relative flex size-14 shrink-0 cursor-pointer flex-col items-center justify-center gap-1 rounded-xl transition-colors contrast:border contrast:border-border',
  variants: {
    isSelected: {
      true: 'bg-primary text-primary-foreground',
      false: 'bg-card shadow-card',
    },
  },
});

const label = tv({
  base: '',
  variants: {
    tone: {
      selected: 'text-primary-foreground',
      today: 'text-primary',
      empty: 'text-subtle-foreground',
      regular: 'text-foreground',
    },
  },
});

interface Props {
  date: Date;
  isSelected: boolean;
  isToday: boolean;
  isEmpty: boolean;
  hasChanges: boolean;
  onClick: () => void;
}

const resolveTone = ({
  isSelected,
  isToday,
  isEmpty,
}: Pick<Props, 'isSelected' | 'isToday' | 'isEmpty'>) => {
  if (isSelected) {
    return 'selected';
  }

  if (isToday) {
    return 'today';
  }

  return isEmpty ? 'empty' : 'regular';
};

export const DateCarouselItem: React.FC<Props> = ({
  date,
  isSelected,
  isToday,
  isEmpty,
  hasChanges,
  onClick,
}) => {
  const tone = resolveTone({ isSelected, isToday, isEmpty });

  return (
    <button type="button" className={item({ isSelected })} onClick={onClick}>
      <span className={label({ tone, className: 'text-subhead-14' })}>
        {formatNarrowWeekday(date)}
      </span>
      <span className={label({ tone, className: 'text-body-13' })}>
        {date.getDate()}
      </span>
      {hasChanges && (
        <span className="absolute top-1.5 right-1.5 size-1.5 rounded-full bg-accent" />
      )}
    </button>
  );
};
